import { parseQuery } from "@/utils/url";
import { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import errorRoutes from "./error";

const Layout = () => import("@/layout/index.vue");

const urlTitle = parseQuery(location.href)?.title ? decodeURIComponent(parseQuery(location.href)?.title) : "用户认证";

async function signingGuard(to: RouteLocationNormalized) {
  return true;
}

export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      title: "登录",
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/sign",
    name: "Sign",
    component: () => import("@/views/sign/qrcode/index.vue"),
    meta: {
      title: "视频认证",
      showLink: false
    }
  },
  {
    path: "/miniShare",
    name: "MiniShare",
    component: () => import("@/views/system/role/miniShare.vue"),
    meta: {
      title: "视频认证",
      showLink: false
    }
  },
  {
    path: "/nsearch",
    name: "Nsearch",
    component: () => import("@/views/static/notarization/toMimi.vue"),
    meta: {
      title: "查询公证书",
      showLink: false
    }
  },
  {
    path: "/minisearch",
    name: "Minisearch",
    component: () => import("@/views/static/notarization/index.vue"),
    meta: {
      title: "查询公证书",
      showLink: false
    }
  },
  {
    path: "/minisearchByNo",
    name: "MinisearchByNo",
    component: () => import("@/views/static/notarization/search.vue"),
    meta: {
      title: "查询公证书",
      showLink: false
    }
  },
  {
    path: "/tcfb",
    name: "Tcfb",
    component: () => import("@/views/deposit/feedback/index.vue"),
    meta: {
      title: "逾期反馈",
      showLink: false
    }
  },
  {
    path: "/tcfblist",
    name: "Tcfblist",
    component: () => import("@/views/deposit/feedback/list.vue"),
    meta: {
      title: "逾期列表",
      showLink: false
    }
  },
  {
    path: "/playvideo",
    name: "PlayVideo",
    component: () => import("@/views/static/before/video.vue"),
    meta: {
      title: "办理告知",
      showLink: false
    }
  },
  {
    path: "/sr",
    name: "Sr",
    component: () => import("@/views/mobile/srTab.vue"),
    meta: {
      title: "查询公证书",
      showLink: false
    }
  },
  {
    path: "/hp",
    name: "Hp",
    component: () => import("@/views/static/pay/h5.vue"),
    meta: {
      title: "费用支付",
      showLink: false
    }
  },
  {
    path: "/spay/:id",
    name: "Spay",
    component: () => import("@/views/static/pay/spay.vue"),
    meta: {
      title: "平台跳转",
      showLink: false
    }
  },
  {
    path: "/pgz/:id",
    name: "Pgz",
    component: () => import("@/views/static/pay/gz.vue"),
    meta: {
      title: "确认费用",
      showLink: false
    }
  },
  {
    path: "/openMini",
    name: "OpenMini",
    component: () => import("@/views/static/mini/open.vue"),
    meta: {
      title: "前往渝公证小程序",
      showLink: false
    }
  },
  {
    path: "/video/chat",
    name: "VideoChat",
    component: () => import("@/views/static/video/chat.vue"),
    meta: {
      title: "视频认证",
      showLink: false
    }
  },
  {
    path: "/mini/sourceForm",
    name: "MiniBusinessSourceForm",
    component: () => import("@/views/business/editor/sourceForm.vue"),
    meta: {
      title: "数据管理",
      showLink: false
    }
  },
  {
    path: "/mini/business",
    name: "MiniBusiness",
    component: () => import("@/views/business/editor/app.vue"),
    meta: {
      title: "业务表单",
      showLink: false
    }
  },
  // 白名单路由：未登录可访问（无侧边栏）
  {
    path: "/business/api/index",
    name: "BusinessApiIndex",
    component: () => import("@/views/business/api/index.vue"),
    meta: {
      title: "业务接口",
      showLink: false
    }
  },
  // 已登录路由：带侧边栏布局
  {
    path: "/business/api",
    component: Layout,
    redirect: "/business/api/doc",
    meta: {
      title: "业务接口",
      showLink: false,
      rank: 104
    },
    children: [
      {
        path: "/business/api/doc",
        name: "BusinessApiDoc",
        component: () => import("@/views/business/api/index.vue"),
        meta: {
          title: "业务接口",
          showLink: false
        }
      }
    ]
  },
  {
    path: "/autologin",
    name: "Autologin",
    component: () => import("@/views/static/autologin/index.vue"),
    meta: {
      title: urlTitle,
      showLink: false
    }
  },
  {
    path: "/inner",
    name: "Inner",
    component: Layout,
    redirect: "/inner/userinfo",
    meta: {
      title: "个人中心",
      showLink: false,
      rank: 99
    },
    children: [
      {
        path: "/inner/userinfo",
        name: "InnerUserInfo",
        component: () => import("@/views/system/userInfo/index.vue"),
        meta: {
          title: "个人信息",
          showLink: false
        }
      }
    ]
  },
  {
    path: "/redirect",
    component: Layout,
    meta: {
      title: "加载中...",
      showLink: false,
      rank: 102
    },
    children: [
      {
        path: "/redirect/:path(.*)",
        name: "Redirect",
        component: () => import("@/layout/redirect.vue")
      }
    ]
  },
  {
    path: "/mobile",
    redirect: "/mobile/progress",
    meta: {
      title: "签署",
      showLink: false,
      rank: 103
    },
    children: [
      {
        path: "to-sign",
        name: "to-sign",
        component: () => import("@/views/mobile/toSign.vue")
      },
      {
        path: "progress",
        name: "mobile-progress",
        beforeEnter: [signingGuard],
        component: () => import("@/views/mobile/progress.vue")
      },
      {
        path: "card",
        name: "mobile-card",
        beforeEnter: [signingGuard],
        component: () => import("@/views/mobile/card.vue")
      },
      {
        path: "watch-video",
        name: "mobile-watch-video",
        beforeEnter: [signingGuard],
        component: () => import("@/views/mobile/WatchVideo.vue")
      },
      {
        path: "record-video",
        name: "mobile-record-video",
        beforeEnter: [signingGuard],
        component: () => import("@/views/mobile/recordVideo.vue")
      },
      {
        path: "connect",
        name: "mobile-connect",
        beforeEnter: [signingGuard],
        component: () => import("@/views/mobile/connect.vue")
      },
      {
        path: "video",
        name: "mobile-video",
        beforeEnter: [signingGuard],
        component: () => import("@/views/mobile/video.vue")
      },
      {
        path: "finish",
        name: "mobile-finish",
        component: () => import("@/views/mobile/finish.vue")
      },
      {
        path: "guard",
        name: "mobile-guard",
        component: () => import("@/views/mobile/guard.vue")
      },
      {
        path: "fundVerfy",
        name: "fund-verfy",
        component: () => import("@/views/mobile/fundVerfy.vue")
      },
      {
        path: "fundDocument",
        name: "fund-document",
        component: () => import("@/views/mobile/fundDocument.vue")
      },
      {
        path: "fundFinish",
        name: "fund-finish",
        component: () => import("@/views/mobile/fundFinish.vue")
      },
      {
        path: "preview-document",
        name: "mobile-preview-document",
        component: () => import("@/views/mobile/PreviewDocument.vue")
      },
      {
        path: "procureVerfy",
        name: "procure-verfy",
        component: () => import("@/views/mobile/procureVerfy.vue")
      },
      {
        path: "procureDocument",
        name: "procure-document",
        component: () => import("@/views/mobile/procureDocument.vue")
      },
      {
        path: "procureFinish",
        name: "procure-finish",
        component: () => import("@/views/mobile/procureFinish.vue")
      },
      {
        path: "remoteVideo",
        name: "remote-video",
        component: () => import("@/views/mobile/remoteVideo/index.vue")
      },
      // {
      //   path: "remoteDetail",
      //   name: "remote-detail",
      //   component: () => import("@/views/mobile/remoteVideo/Detail.vue")
      // },
      {
        path: "remoteChat",
        name: "remote-video-chat",
        component: () => import("@/views/mobile/remoteVideo/Video.vue")
      },
      {
        path: "qa-result",
        name: "qa-result",
        component: () => import("@/views/mobile/qaResult.vue")
      },
      {
        path: "factoringVerfy",
        name: "factoring-verfy",
        component: () => import("@/views/mobile/factoringVerfy.vue")
      },
      {
        path: "factoringDocument",
        name: "factoring-document",
        component: () => import("@/views/mobile/factoringDocument.vue")
      },
      {
        path: "factoringFinish",
        name: "factoring-finish",
        component: () => import("@/views/mobile/factoringFinish.vue")
      },
      {
        path: "microcreditVerfy",
        name: "microcredit-verfy",
        component: () => import("@/views/mobile/microcreditVerfy.vue")
      },
      {
        path: "microcreditDocument",
        name: "microcredit-document",
        component: () => import("@/views/mobile/microcreditDocument.vue")
      },
      {
        path: "microcreditFinish",
        name: "microcredit-finish",
        component: () => import("@/views/mobile/microcreditFinish.vue")
      },
    ]
  },
  errorRoutes
] as Array<RouteConfigsTable>;
